const langISO = Object.freeze({
  'en-US': ['English'], // en-US
  //印度英语  印度地区
  // 'en-IN': ['Indian English'], // en-IN  在sportradar没有这个语言
  // 越南语
  'vi-VN': ['Tiếng việt'], // vi-VN
  // 印度尼西亚语
  // 'id-ID': ['Indonesian'], // id-ID
  // 日本语
  'ja-JP': ['日本語'], // ja-JP
  // 韩语
  'ko-KR': ['한국어'], // ko-KR
  // 法语
  'fr-FR': ['Français'], // fr-FR
  // 西班牙语
  'es-ES': ['Español'], // es-ES
  // 菲律宾语
  // 'fil-PH': ['Filipino'], // fil-PH 在sportradar没有这个语言
  // 阿拉伯语
  'ar-SA': ['عربى'], // ar-SA
  // 印地语
  // 'hi-IN': ['हिन्दी'], // hi-IN
  // 土耳其语
  'tr-TR': ['Türkçe'], // tr-TR
  // 波斯语
  // 'fa-IR': ['فارسی'], // fa-IR
  // 葡萄牙语(巴西)
  'pt-BR': ['Português'], // pt-BR
  // 俄语
  'ru-RU': ['Руccкий'], // ru-RU
  // 德语
  'de-DE': ['Deutsch'], // de-DE
  // 泰语
  // 'th-TH': ['ภาษาไทย'], // th-TH
  // 芬兰
  'fi-FI': ['Suomi'], // fi-FI
  // 波兰
  'pl-PL': ['Polski'], // pl-PL
  // 意大利
  'it-IT': ['Italiano'], // it-IT
  // 缅甸语 Burmese
  // 'my-MM': ['မြန်မာ'], // my-MM
  // 荷兰语 Dutch 暂时去掉荷兰语
  //"nl": ["Nederlands", "nl-NL"],
  // 乌尔都语（巴基斯坦）Urdu (Pakistan)
  // 'ur-PK': ['اردو'], // ur-PK
  // 乌克兰语
  'uk-UA': ['Українська'], // uk-UA
  // 马来西亚语
  // 'ms-MY': ['Melayu'], // ms-MY
  // 孟加拉语
  // 'bn-BD': ['বাংলা'], // bn-BD
  // 马拉地语  印度地区
  // 'mr-IN': ['Marathi'], // mr-IN
  // 泰米尔语  印度地区
  // 'ta-IN': ['Tamil'], // ta-IN
  // 泰卢固语  印度地区
  // 'te-IN': ['Telugu'], // te-IN
  // 繁体中文
  'zh-TW': ['繁體中文'], // zh-TW
  // 简体中文
  'zh-CN': ['简体中文'], // zh-CN
  // 亚美尼亚语
  // 'hy-AM': ['Հայերեն'], // hy-AM
} as const);

export default langISO;

export const sportradarLangISO = Object.freeze({
  'en-US': 'en',
  //印度英语  印度地区
  // 'en-IN': 'en', // 在sportradar没有这个语言
  // 越南语
  'vi-VN': 'vi',
  // 印度尼西亚语
  // 'id-ID': 'id',
  // 日本语
  'ja-JP': 'ja',
  // 韩语
  'ko-KR': 'ko',
  // 法语
  'fr-FR': 'fr',
  // 西班牙语
  'es-ES': 'es',
  // 菲律宾语
  // 'fil-PH': 'fil', // 在sportradar没有这个语言
  // 阿拉伯语
  'ar-SA': 'aa',
  // 印地语
  // 'hi-IN': 'hi',
  // 土耳其语
  'tr-TR': 'tr',
  // 波斯语
  // 'fa-IR': 'en', // 波斯语在sportradar没有这个语言,默认为en
  // 葡萄牙语(巴西)
  'pt-BR': 'pt',
  // 俄语
  'ru-RU': 'ru',
  // 德语
  'de-DE': 'de',
  // 泰语
  // 'th-TH': 'th',
  // 芬兰
  'fi-FI': 'fi',
  // 波兰
  'pl-PL': 'pl',
  // 意大利
  'it-IT': 'it',
  // 缅甸语 Burmese
  // 'my-MM': 'en', // 缅甸语在sportradar没有这个语言,默认为en
  // 荷兰语 Dutch 暂时去掉荷兰语
  // 'nl-NL': 'nl',
  // 乌尔都语（巴基斯坦）Urdu (Pakistan)
  // 'ur-PK': 'ur',
  // 乌克兰语
  'uk-UA': 'ukr',
  // 马来西亚语
  // 'ms-MY': 'en', // 马来西亚语在sportradar没有这个语言,默认为en
  // 孟加拉语
  // 'bn-BD': 'en', // 孟加拉语在sportradar没有这个语言,默认为en
  // 马拉地语  印度地区
  // 'mr-IN': 'en', // 马拉地语在sportradar没有这个语言,默认为en
  // 泰米尔语  印度地区
  // 'ta-IN': 'en', // 泰米尔语在sportradar没有这个语言,默认为en
  // 泰卢固语  印度地区
  // 'te-IN': 'en', // 泰卢固语在sportradar没有这个语言,默认为en
  // 繁体中文
  'zh-TW': 'zht',
  // 简体中文
  'zh-CN': 'zh',
  // 亚美尼亚语
  // 'hy-AM': 'hy',
} as const);
